import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ComponentBase, DialogData, SelectCreateComponentStyle } from '@definitiv-packages/angular-dba-library';

import { ObjektModelView, ObjektViewService, ProjectLanguage, ServiceModel, ServiceModelView, ServiceService} from '../../../../../roofsafetymanagement-library/src/public-api';
import { SysServiceRythmusService } from '../../../../../roofsafetymanagement-library/src/lib/services/Models/sys-service-rythmus-model.service';
import { SysServiceRythmusModel } from '../../../../../roofsafetymanagement-library/src/lib/types/SysServiceRythmusModel';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-create-service',
  templateUrl: './create-service.component.html',
  styleUrls: ['./create-service.component.scss'],
  standalone: false
})
export class CreateServiceComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  //#region 
  public Title: string = "";
  public service: ServiceModel | null = null;
  public objektList: ObjektModelView[] = [];
  public rythmusList: SysServiceRythmusModel[] = [];
  private ObjektControl: FormControl<ObjektModelView | null> = new FormControl<ObjektModelView | null>(null);
  private LaufzeitVonControl: FormControl<Date | null> = new FormControl<Date | null>(null);
  private LaufzeitBisControl: FormControl<Date | null> = new FormControl<Date | null>(null);
  private IntervallControl: FormControl<number | null> = new FormControl<number | null>(null, Validators.max(36));
  private ServiceRythmusControl: FormControl<SysServiceRythmusModel | null> = new FormControl<SysServiceRythmusModel | null>(null);

  public FormGroup = new UntypedFormGroup({
    objektControl: this.ObjektControl,
    laufzeitvonControl: this.LaufzeitVonControl,
    laufzeitbisControl: this.LaufzeitBisControl,
    intervallControl: this.IntervallControl,
    ServiceRythmusControl: this.ServiceRythmusControl
  });

  public styleList: SelectCreateComponentStyle<ObjektModelView>[] = [
    { selectName: 'DebitorNummer', cssClass: 'alignleft' },
    { selectName: 'DebitorName', cssClass: 'alignleft' },
    { selectName: 'Bezeichnung', cssClass: 'alignleft' },
    { selectName: 'PLZ', cssClass: 'alignleft' },
    { selectName: 'Ort', cssClass: 'alignleft' },
    { selectName: 'LandName', cssClass: 'alignleft' },
  ];

  //#endregion
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData<ServiceModelView>,
    public dialogRef: MatDialogRef<CreateServiceComponent>,
    public serviceService: ServiceService,
    private datepipe: DatePipe,
    public sysServiceRythmusService : SysServiceRythmusService,
    public objektService: ObjektViewService
  ) { super(); }

  public async ngOnInit() {
    this.loading = true;

    this.objektList = await this.objektService.getList();
    this.rythmusList = await this.sysServiceRythmusService.getList();

    if (this.data.mode == 'create') {
      this.Title = this.languageService.getText(this.language.serviceerstellen);
    } else if (this.data.mode == 'edit') {
      this.Title = this.languageService.getText(this.language.servicebearbeiten);
    }

    if (this.data.data) {
      this.service = await this.serviceService.get(this.data.data.ServiceID);

      this.LaufzeitVonControl.setValue(this.service.LaufzeitVon)
      this.LaufzeitBisControl.setValue(this.service.LaufzeitBis)
      this.IntervallControl.setValue(this.service.Intervall)
      this.ServiceRythmusControl.setValue(this.rythmusList.find(x=>x.ServicerythmusId == this.service?.ServicerythmusID)!);

      if (this.service.ObjektID)
        this.ObjektControl.setValue(this.objektList.find(x => x.ObjektID == this.service?.ObjektID)!);
    }
    else {
      this.service = {} as ServiceModel;
    }
    this.loading = false;
  }

  public async Save(): Promise<void> {
    this.FormGroup.markAllAsTouched();
    this.FormGroup.updateValueAndValidity();
    if (this.FormGroup.valid) {

      this.loading = true;
      this.service = new ServiceModel();

      if (this.data.mode == 'edit' && this.data.data)
        this.service.ServiceID = this.data.data.ServiceID;

      this.service.LaufzeitVon = null;
      this.service.LaufzeitBis = null;

      if(this.LaufzeitVonControl.value){
        this.service.LaufzeitVon =  new Date(this.datepipe.transform(this.LaufzeitVonControl.value!,'yyyy-MM-dd')!);
      }      

      if(this.LaufzeitVonControl.value){
        this.service.LaufzeitBis =  new Date(this.datepipe.transform(this.LaufzeitBisControl.value!,'yyyy-MM-dd')!);
      }            

      this.service.Intervall = this.IntervallControl.value;

      if (this.ObjektControl.value)this.service.ObjektID = this.ObjektControl.value.ObjektID!;
      if (this.ServiceRythmusControl.value)this.service.ServicerythmusID = this.ServiceRythmusControl.value.ServicerythmusId;

      try {

          if (this.service.ServiceID > 0) {
              var Item = await this.serviceService.put(this.service.ServiceID, this.service)
          }else{
              var Item = await this.serviceService.post(this.service)
          }
        
          this.loading = false;
          this.dialogRef.close(Item);
      }catch{
        
          this.loading = false;
      }

    }
  }
}
